import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// 🧱 Layout protegido (RequireAuth + Menu flutuante)
import ProtectedLayout from './layouts/ProtectedLayout';

// Login + fluxo inicial
import Login from './pages/login/Login';
import Redirector from './pages/redirect/Redirector';
import Quiz from './pages/quiz/Quiz';
import Introducao from './pages/introducao/Introducao';
import Resultado from './pages/resultado/Resultado';
import Home from './pages/home/Home';
import RequireGuest from './components/auth/RequireGuest';


// 🔐 Redefinição de senha
import ResetPass from './pages/resetpass/resetpass';

// Página de níveis
import PaginaNivel from './pages/nivel/PaginaNivel';

// página de extrato de moedas
import PaginaExtratoMoedas from './pages/extrato/PaginaExtratoMoedas';

// Painel principal
import Painel from './pages/painel/Painel';

// 📊 Estatísticas
import Estatisticas from './pages/estatisticas/estatisticas';

// 📅 Calendário (antes recap)
import Recap from './pages/recap/Recap';

// 🧠 Resumo inteligente (NOVO)
import Resumo from './pages/resumo/Resumo';

// Bate-papo IA
import BatePapo from './pages/batepapo/BatePapo';

// Página de perfil
import Perfil from './pages/perfil/Perfil';

// Página de planos
import PaginaPlanos from './pages/painel/PaginaPlanos';

// Página de restrições
import Restricoes from './pages/restricoes/Restricoes';

// 🍽️ Página de cardápios
import Cardapios from './pages/cardapios/Cardapios';

function App() {
  return (
    <Router>
      <Routes>

        {/* =============================
            FLUXO ABERTO
        ============================== */}
        <Route
  path="/"
  element={
    <RequireGuest>
      <Home />
    </RequireGuest>
  }
/>
        <Route path="/redirect" element={<Redirector />} />
        <Route path="/login" element={<Login />} />
        <Route path="/redefinir-senha" element={<ResetPass />} />

        {/* =============================
            FLUXO PROTEGIDO (COM MENU)
        ============================== */}
        <Route
          path="/quiz"
          element={
            <ProtectedLayout>
              <Quiz />
            </ProtectedLayout>
          }
        />

        
        <Route
  path="/nivel"
  element={
    <ProtectedLayout>
      <PaginaNivel />
    </ProtectedLayout>
  }
/>


        <Route
          path="/introducao"
          element={
            <ProtectedLayout>
              <Introducao />
            </ProtectedLayout>
          }
        />

        <Route
          path="/resultado"
          element={
            <ProtectedLayout>
              <Resultado />
            </ProtectedLayout>
          }
        />


<Route
  path="/extrato"
  element={
    <ProtectedLayout>
      <PaginaExtratoMoedas />
    </ProtectedLayout>
  }
/>


        <Route
          path="/restricoes"
          element={
            <ProtectedLayout>
              <Restricoes />
            </ProtectedLayout>
          }
        />

        <Route
          path="/cardapios"
          element={
            <ProtectedLayout>
              <Cardapios />
            </ProtectedLayout>
          }
        />

        <Route
          path="/painel"
          element={
            <ProtectedLayout>
              <Painel />
            </ProtectedLayout>
          }
        />

        <Route
          path="/estatisticas"
          element={
            <ProtectedLayout>
              <Estatisticas />
            </ProtectedLayout>
          }
        />

        <Route
          path="/calendario"
          element={
            <ProtectedLayout>
              <Recap />
            </ProtectedLayout>
          }
        />

        {/* 🧠 NOVA ROTA — RESUMO INTELIGENTE */}
        <Route
          path="/resumo"
          element={
            <ProtectedLayout>
              <Resumo />
            </ProtectedLayout>
          }
        />

        <Route
          path="/batepapo"
          element={
            <ProtectedLayout>
              <BatePapo />
            </ProtectedLayout>
          }
        />

        <Route
          path="/perfil"
          element={
            <ProtectedLayout>
              <Perfil />
            </ProtectedLayout>
          }
        />

        {/* =============================
            PLANOS (mantido como estava)
        ============================== */}
        <Route path="/acesso" element={<PaginaPlanos />} />

      </Routes>
    </Router>
  );
}

export default App;
